module.exports = __webpack_public_path__ + "static/media/block.9a7ada10.svg";